import React, { useCallback, useEffect, useState } from "react";

import { getAllAdminNews } from "services";

import { goTo, useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminTable, Button, Col, MainPage, Row } from "components";

export const News = () => {
  const [loading, setLoading] = useState(true);
  const [news, setNews] = useState([]);
  const signal = useCancelAsyncOnUnmount()();

  const openItem = (item) => {
    goTo(null, null, `${process.env.REACT_APP_FARM_URL}/news/${item.link}`, true);
  };

  const loadAllNews = useCallback(() => {
    getAllAdminNews({
      signal,
    })
      .then((res) => {
        setNews(res.length > 0 ? res : []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  useEffect(() => {
    loadAllNews();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline={`${news.length} news posts`}
        description="View, update or add news posts here."
        extra={
          <Button size="small" type="secondary" href="/news/add">
            Add
          </Button>
        }
      />
      <Row>
        <Col>
          <AdminTable
            dataSource={news}
            config={{
              exclude: ["image", "link", "content", "lastYear", "summary", "date", "utc", "methods"],
              actions: [
                {
                  icon: "tabler/edit",
                  route: "/news/update/",
                  tooltip: "Edit this news post",
                },
                {
                  icon: "tabler/eye",
                  func: openItem,
                  tooltip: "View this news post",
                },
              ],
            }}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
